import { useContext } from 'react';
import { JobsContext } from '@jobs/contexts/jobsContext';

const useJobs = () => {
  const context = useContext(JobsContext);
  if (!context) {
    throw new Error('useJobs must be used within a JobsProvider');
  }
  return context;
};

export default useJobs;
